import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { ApiRoutes } from './api-routes.consts';

@Injectable({
  providedIn: 'root',
})
export class ContactsApiService {
  public constructor(
    private readonly httpService: BaseHttpService,
    private readonly httpClient: HttpClient,
  ) {}

  public searchNimbusContacts(searchInput: string): Observable<any[]> {
    const contactRequestBatchSize = 20;
    return this.httpService.post(this.composeContactsRequest(`${ApiRoutes.Contacts.search()}`, searchInput, contactRequestBatchSize));
  }

  public getNimbusContactIcon(imageUrl: string): Observable<Blob> {
    return this.httpClient.get(imageUrl, {
      responseType: 'blob',
      headers: new HttpHeaders({ 'Content-Type': 'image/jpeg' }),
    });
  }
  private composeContactsRequest(url: string, searchInput: string, pageSize: number): string {
    return `${url}?$top=${pageSize}&$skip=0&query=${searchInput}&$orderBy=DisplayName asc`;
  }
}
